import React from 'react'

const FlyerHeadLogo = ({
    logoData,
    formartedCurrentPeriodeStartDate,
    formartedCurrentPeriodeEndDate
}) => {
    const { flyer_url, flyer_logo_subtitle } = logoData
    
    return (
        <div>
            {flyer_url && <div className="logo-container"><div className="logo" style={{backgroundImage: `url(${flyer_url})`}}></div></div>}

            {flyer_logo_subtitle && <div className="flyer-logo-subtitle-container">{flyer_logo_subtitle}</div>}

            {formartedCurrentPeriodeStartDate && formartedCurrentPeriodeEndDate && <div className="week-container-inside">von {formartedCurrentPeriodeStartDate} bis {formartedCurrentPeriodeEndDate}</div>}
        </div>
    )
}

export default FlyerHeadLogo